/**
 * Phone layout for the homepage cms sections (see snippets/cms-mobile.liquid and assets/cms-mobile.css).
 * Adds a "show more" button to each section (the CSS hides the extra content on phones only) and turns Visit's
 * three boxes into tap-to-open rows. On wider screens the buttons are hidden and nothing is collapsed.
 */
const SECTIONS = [
  { root: '.cms-picks', more: '.cms-picks__wall > li:nth-child(n + 5)', after: '.cms-picks__wall', label: (n) => `Show all ${n + 4} picks` },
  { root: '#store', more: '.depts > .dept:nth-of-type(n + 4), .brands', after: '.depts', label: () => 'See all departments' },
  { root: '.cms-sec.pro', more: '.pro-photo, .rates', after: '.finder', label: () => 'See photos and the full rate card' },
  { root: '#gift-cards', more: '.facts', after: '.amounts', label: () => 'How gift cards work' },
  { root: '.cms-map .share', more: 'ol', after: 'h3', label: () => 'How to get your trip on the map' },
  { root: '#team', more: '.caps, .worn, .jersey', after: '.intro', label: () => 'See what we do' },
];

const PHONE = window.matchMedia('(max-width: 700px)');

function setUp(scope) {
  for (const c of SECTIONS) {
    for (const root of scope.querySelectorAll(c.root)) {
      if (root.dataset.mReady) continue;
      const after = root.querySelector(c.after);
      const more = root.querySelectorAll(c.more);
      if (!after || !more.length) continue;
      root.dataset.mReady = '1';
      const label = c.label(more.length);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'm-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = label;
      after.insertAdjacentElement('afterend', button);
      button.addEventListener('click', () => {
        const open = !root.classList.contains('m-open');
        root.classList.toggle('m-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? 'Show less' : label;
        if (!open && root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start' });
      });
    }
  }
  // Visit: tap-to-open rows, phones only (Hours starts open so the times are visible straight away)
  if (!PHONE.matches) return;
  for (const box of scope.querySelectorAll('.cms-sec.visit .vbox')) {
    const heading = box.querySelector(':scope > h3');
    if (box.dataset.mReady || !heading) continue;
    box.dataset.mReady = '1';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'm-acc-btn';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = heading.textContent.trim();
    heading.textContent = '';
    heading.appendChild(button);
    const toggle = (open) => {
      box.classList.toggle('m-open', open);
      box.classList.toggle('m-shut', !open);
      button.setAttribute('aria-expanded', String(open));
    };
    button.addEventListener('click', () => toggle(!box.classList.contains('m-open')));
    if (box.querySelector('.hours')) toggle(true);
  }
}

setUp(document);
PHONE.addEventListener('change', () => { if (PHONE.matches) setUp(document); });
document.addEventListener('shopify:section:load', (event) => setUp(event.target));
